import React, {Component} from 'react';
import {Container, Row, Col, CardGroup, Card, CardBody, Button, Input, InputGroup, InputGroupAddon, InputGroupText} from 'reactstrap';
import { inject, observer } from "mobx-react";

@inject("userStore", "newsStore") @observer
class Login extends Component {

  state = {
    email: "",
    password: "",
    isLoading: false,
    apiMode: '',
    listBan: [],
  };

  componentDidMount() {
    const { userStore } = this.props;
    const apiMode = window.localStorage.getItem('admin_api_mode') || 'production_empty';
    this.setState({apiMode});
    if (!!userStore.userData.name) {
      document.location = "/#/dashboard";
      return;
    }
    this.getListBanUser();
  }

  getListBanUser = async () => {
    const { newsStore } = this.props;
    const listBan = await newsStore.getBanUserAdmin();
    console.log('listBan', listBan);
    this.setState({ listBan });
  }

  handleLogin = async (e) => {
    e.preventDefault();
    
    const { email, password, listBan } = this.state;
    if (listBan.includes(email)) {
      return alert('Tài khoản này không có quyền truy cập vào admin');
    }
    const { userStore } = this.props;

    this.setState({isLoading: true});
    let loginResult = await userStore.loginNormal({ email, password });
    this.setState({isLoading: false});
    if (!!loginResult.error) return alert(loginResult.error);
    console.log(loginResult);

    document.location = "/#/dashboard";
    window.location.reload();
  };

  render() {
    const { isLoading, apiMode } = this.state;

    const options = [
      { value: 'production_empty', label: 'Demo.dev.houselink.info' },
      { value: 'production_dev', label: 'Web.dev.houselink.info' },
      { value: 'development', label: 'Development' },
      { value: 'localhost', label: 'Localhost' },
    ];
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <h1>Login</h1>
                    <p className="text-muted">Sign In</p>
                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-user"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input type="text" placeholder="Email" value={this.state.email} onChange={e => this.setState({email: e.target.value}) } />
                    </InputGroup>
                    <InputGroup className="mb-4">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-lock"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input type="password" placeholder="Password" value={this.state.password} onChange={e => this.setState({password: e.target.value}) } />
                    </InputGroup>
                    <div className="form-group">
                      <label>Choose server</label>
                      <select className="form-control" value={apiMode} onChange={(e) => {
                          this.setState({apiMode: e.target.value});
                          window.localStorage.setItem('admin_api_mode', e.target.value);
                        }}
                      >
                        {
                          options.map(item => <option key={item.value} value={item.value}>{item.label}</option>)
                        }
                      </select>
                    </div>
                    <Row>
                      <Col xs="6">
                        <Button color="primary" className="px-4" disabled={isLoading} onClick={this.handleLogin}>{isLoading ? 'Login...' : 'Login'}</Button>
                      </Col>
                      <Col xs="6" className="text-right">
                        {/* <Button color="link" className="px-0">Forgot password?</Button> */}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Card className="text-white bg-primary py-5 d-md-down-none" style={{ width: 44 + '%' }}>
                  <CardBody className="text-center">
                    <div>
                      <h2>Sign up</h2>
                      <p>Currently not available. <br />Please contact system admin!</p>
                      {/* <Button color="primary" className="mt-3" active>Register Now!</Button> */}
                    </div>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js